/**
 * en-GB messages added by Phase 2 task C2 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const c2EnGB = {
    'error.idempotency_key_required': 'Send an Idempotency-Key header of 8 to 100 characters with this request.',
    'error.idempotency_key_invalid': 'The Idempotency-Key must be 8 to 100 printable characters.',
    'error.idempotency_conflict': 'This Idempotency-Key was already used with a different request.',
};
//# sourceMappingURL=c2.js.map